
import React from 'react';
import Location from '@nmx/utils-frontend/dist/utilities/frontend/location';
import Session from '@nmx/utils-frontend/dist/utilities/frontend/session';
// images
// hero images
import blackAaHeroDesktopWebp from '../components/heroSection/images/black-aa-hero-desktop.webp';
import blackAaHeroMobileWebp from '../components/heroSection/images/black-aa-hero-mobile.webp';
import defaultCareerChangersDesktopWebp from '../components/heroSection/images/default-career-changers-desktop.webp';
import defaultCareerChangersMobileWebp from '../components/heroSection/images/default-career-changers-mobile.webp';
import womenHeroDesktopWebp from '../components/heroSection/images/women-hero-desktop.webp';
import womenHeroMobileWebp from '../components/heroSection/images/women-hero-mobile.webp';
// financial planning section 1 images
import blackAaWomenCareerChangersDesktopWebp from '../components/financialPlanningSection1/images/black-aa-women-desktop.webp';
import blackAaWomenCareerChangersMobileWebp from '../components/financialPlanningSection1/images/black-aa-women-mobile.webp';
import generalCareerChangersDesktopWebp from '../components/financialPlanningSection1/images/career-changers-desktop.webp';
import generalCareerChangersMobileWebp from '../components/financialPlanningSection1/images/career-changers-mobile.webp';

// Possible utm_content parameter value substrings
// WOMEN: rec-wom-US
// BLACK/AA LOCAL: rec-AA-SARE
// BLACK/AA NATIONAL: rec-AA-US
// GENERAL AUDIENCE: rec-broad-US (default)

export const getCampaignData = (isTesting, testingCampaignName) => {
  const pageData = {
    // default experience /////////////////////////////////////////////////////
    default: {
      campaignName: 'default',
      heroSection: {
        // images
        desktopImageWebp: defaultCareerChangersDesktopWebp.toString(),
        mobileImageWebp: defaultCareerChangersMobileWebp.toString(),
        // content
        heroImageAltText: 'A smiling business man talking to a client',
      },
      financialPlanningSection1: {
        // images
        desktopImageWebp: generalCareerChangersDesktopWebp.toString(),
        mobileImageWebp: generalCareerChangersMobileWebp.toString(),
        // content
        bulletTextArray: [
          { bulletText: (<>You&#39;ll form lasting relationships with your clients, helping them see their financial big picture and reach goals like buying a home, sending their kids to college, and having the retirement of their dreams.</>) },
          { bulletText: (<>You&#39;ll learn proven practices designed to grow your career and put you in control of your time and your future.</>) },
          { bulletText: (<>With offices nationwide, you&#39;ll be able to build the career you want in the community you love.</>) },
        ],
        subText: (<>With Northwestern Mutual, you&#39;ll have the opportunity to build your own business, backed by a <strong><em>FORTUNE&#174; 500</em></strong> company, while helping people build their best lives.</>),
      },
    },
    // women (rec-wom-US) experience /////////////////////////////////////////////////////
    women: {
      campaignName: 'rec-wom', // only used for section ID of hero and as a potentiasl prop to style against
      heroSection: {
        // images
        desktopImageWebp: womenHeroDesktopWebp.toString(),
        mobileImageWebp: womenHeroMobileWebp.toString(),
        // content
        heroImageAltText: 'A smiling business woman looking out of an office window',
      },
      financialPlanningSection1: {
        // images
        desktopImageWebp: blackAaWomenCareerChangersDesktopWebp.toString(),
        mobileImageWebp: blackAaWomenCareerChangersMobileWebp.toString(),
        // content
        bulletTextArray: [
          { bulletText: (<>You&#39;ll form lasting relationships with your clients, helping them see their financial big picture and reach goals like buying a home, sending their kids to college, and having the retirement of their dreams.</>) },
          { bulletText: (<>You&#39;ll learn proven practices designed to grow your career and put you in control of your time and your future.</>) },
          { bulletText: (<>With offices nationwide, you&#39;ll be able to build the career you want in the community you love.</>) },
        ],
        subText: (<>With Northwestern Mutual, you&#39;ll have the opportunity to shape your career around your life, not the other way around.</>),
      },
    },
    // black experience /////////////////////////////////////////////////////
    black: {
      campaignName: 'rec-aa', // only used for section ID of hero and as a potentiasl prop to style against
      heroSection: {
        // images
        desktopImageWebp: blackAaHeroDesktopWebp.toString(),
        mobileImageWebp: blackAaHeroMobileWebp.toString(),
        // content
        heroImageAltText: 'A black business man smiling while holding a coffee cup and responding to text message',
      },
      financialPlanningSection1: {
        // images
        desktopImageWebp: blackAaWomenCareerChangersDesktopWebp.toString(),
        mobileImageWebp: blackAaWomenCareerChangersMobileWebp.toString(),
        // content
        bulletTextArray: [
          { bulletText: (<>You&#39;ll form lasting relationships with your clients, helping them see their financial big picture and reach goals like buying a home, sending their kids to college, and retiring while leaving a legacy.</>) },
          { bulletText: (<>You&#39;ll learn proven practices designed to grow your career and put you in control of your time and your future.</>) },
          { bulletText: (<>With offices nationwide, you&#39;ll be able to build the career you want in the community you love.</>) },
        ],
        subText: (<>With Northwestern Mutual, you&#39;ll have the opportunity to elevate your career while helping your community rise.</>),
      },
    },
  };

  let thisUtmParam = 'default';
  let dataSetName;
  const thisUtmFromSession = Session.get('utmContent');

  if(Location.hasQueryParam('utm_content')) {
    // capture utm_content param from the URL if present
    thisUtmParam = Location.getQueryParam('utm_content');
  }else if(thisUtmFromSession){
    // capture utm_content param is not present, check and fallback to session storage
    thisUtmParam = thisUtmFromSession;
  }

  // casting utm_content value to lowercase to make the query case insensitive
  thisUtmParam = thisUtmParam.toLowerCase();

  // checking utm_content params and assigning the appropriate dataset
  // the unit tests will ignore query params and pass in their own arguments
  if(isTesting){
    dataSetName = testingCampaignName || 'default';
  }else if(thisUtmParam.includes('rec-wom-us')){
    dataSetName = 'women';
  }else if((thisUtmParam.includes('rec-aa-sare')) || (thisUtmParam.includes('rec-aa-us'))){
    dataSetName = 'black';
  }else{
    dataSetName = 'default';
  }

  return pageData[dataSetName];
};

export default getCampaignData;
